<template>
  <li :class="{ active: activeIndexGrandParent === keyGrandParent }">
    <div class="list-departments__thumb">
      <img
        v-if="grandParent.logo"
        :src="grandParent.logo"
        class="list-departments__img"
        :alt="grandParent.name"
        onerror="this.src='/assets/img/icon-department.png'"
      />
      <img v-else src="/assets/img/icon-department.png" class="list-department__img" loading="lazy" />
    </div>
    <a href="" @click.prevent="selectGrandParent">{{ grandParent.name | ucwords }}</a>
  </li>
</template>

<script>
/* eslint-disable vue/require-prop-types */
export default {
  name: 'item-grand-parent',
  props: {
    keyGrandParent: {
      required: true,
    },
    grandParent: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoadingFinishPopularProduct: false,
      isOpenListCategory: false,
    };
  },
  computed: {
    activeIndexGrandParent() {
      return this.$store.state.header.mobile.activeIndexGrandParent;
    },
  },
  methods: {
    selectGrandParent() {
      this.$emit('selected');

      if (this.activeIndexGrandParent !== this.keyGrandParent) {
        this.$store.commit('updateActiveIndexParent', -1);
        this.$store.commit('updateActiveIndexChild', -1);
      }
      this.$store.commit('updateActiveIndexGrandParent', this.keyGrandParent);
    },
  },
};
</script>
